import { render, staticRenderFns } from "./PurchaseInList.vue?vue&type=template&id=4883cde3&scoped=true"
import script from "./PurchaseInList.vue?vue&type=script&lang=js"
export * from "./PurchaseInList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInList.vue?vue&type=style&index=0&id=4883cde3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883cde3",
  null
  
)

export default component.exports